import React from 'react'
import MaterialSymbol from '../material-symbol'

const CardMembership = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="card_membership" {...props} />
))

CardMembership.displayName = 'CardMembership'

export default CardMembership
